module.exports = __webpack_public_path__ + "img/hk.7428ec1c.svg";